import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { MdEmail } from 'react-icons/md';
import {Button, Spinner} from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
    Row,
    Col,
    Card,
    CardBody,
    Form,
    FormGroup,
    Input,
    Label,
    Alert
} from 'reactstrap';
import Breadcrumb from "../../../../components/Layout/Breadcrumb";
import TipEmailComponent from "../TipEmailComponent";

class ServiceEditEmailComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isSpinner: false,
            emailId: 0,
            title: '',
            subject: '',
            content: '',
            service: '',
            listGroupEmail: [],
            errorForm: false,
            messageErrorForm: '',
            groupEmailId: 0,
            btnSubmit: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getDetailEmail( this.props.emailId );
        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getDetailEmail = (emailId) => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            }
        }
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/email/'+ emailId +'/getDetailEmailService', config)
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        emailId: emailId,
                        listGroupEmail: ref.data.content,
                        groupEmailId: ref.data.email.group_email_id,
                        title: ref.data.email.title,
                        subject: ref.data.email.subject,
                        content: ref.data.email.content,
                        isLoading: false,
                        error: false,
                        messageError: '',
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectFinishBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false,
                        })
                    }
                }
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu thất bại',
                })
            })
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">{ this.state.textNotification } </Alert>
            );
        }
    }

    change = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    createSystemEmail = () => {
        if ( this.validate() ) {
            this.setState({
                isLoading: true,
                errorForm: false,
                btnSubmit: true,
            })
            let form = {
                emailId: this.state.emailId,
                title: this.state.title,
                subject: this.state.subject,
                content: this.state.content,
                groupEmailId: this.state.groupEmailId,
            };
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            // console.log(form);
            axios.put( process.env.REACT_APP_API_URL + '/api/admin/email/editEmailService', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.redirectFinish();
                    } else {
                        if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                            this.props.logOut();
                        }
                        else if ( ref.data.error > 8000 ) {
                            this.redirectFinishBack(ref.data.message);
                        }
                        else {
                            this.setState({
                                errorForm: true,
                                messageForm: ref.data.message,
                                isLoading: false,
                                btnSubmit: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        errorForm: true,
                        messageForm: 'Tạo email thất bại',
                        isLoading: false,
                        name: '',
                        btnSubmit: false
                    })
                })
        }
    }

    validate = () => {
        if ( !this.state.title.length ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Tên Email không được để trống'
            })
            return false;
        }
        else if ( this.state.title.length < 5 || this.state.title.length > 150 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Số ký tự của Tên Email không được nhỏ hơn 5 ký tự hoặc lớn hơn 150 ký tự'
            })
            return false;
        }
        else if ( !this.state.subject.length ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Tiêu đề Email không được để trống'
            })
            return false;
        }
        else if ( this.state.subject.length < 5 || this.state.subject.length > 150 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Số ký tự của Tiêu đề Email không được nhỏ hơn 5 ký tự hoặc lớn hơn 150 ký tự'
            })
            return false;
        }
        else if ( !this.state.groupEmailId ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Nhóm Email không được để trống'
            })
            return false;
        }
        return true;
    }

    redirectFinish = () => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Chỉnh sửa email thành công'
        });
        this.props.redirectFinish();
    }

    redirectFinishBack = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.redirectFinish();
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chỉnh sửa Email"} page={"Email dịch vụ"} icon={<MdEmail className="breadcrumb-icon" />} />
                            <Row style={{ marginTop: 20 }}>
                                <Col sm={12}>
                                    {this.checkNotification()}
                                </Col>
                            </Row>
                            <Form>
                                <Row>
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                <div className='text-center'>{ this.state.messageError }</div>
                                            </Alert>
                                        ) : (
                                            <>
                                                {
                                                    this.state.errorForm ? (
                                                        <Col md={12}>
                                                            <Alert color="danger">
                                                                { this.state.messageErrorForm }
                                                            </Alert>
                                                        </Col>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <Col xl={8} lg={7} md={12}>
                                                    <Card>
                                                        <CardBody>
                                                            <FormGroup>
                                                                <Label for="title">Tên email</Label>
                                                                <Input
                                                                    type="text"
                                                                    id="title"
                                                                    name="title"
                                                                    placeholder="Tên email"
                                                                    defaultValue={this.state.title}
                                                                    onChange={  this.change }
                                                                />
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <Label for="subject">Tiêu đề email</Label>
                                                                <Input
                                                                    type="text"
                                                                    id="subject"
                                                                    name="subject"
                                                                    placeholder="Tiêu đề email"
                                                                    defaultValue={this.state.subject}
                                                                    onChange={ this.change }
                                                                />
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Label for="content">Nội dung email</Label>
                                                                <CKEditor
                                                                    id="content"
                                                                    name="content"
                                                                    config={{placeholder: "Nhập nội dung email..."}}
                                                                    editor={ ClassicEditor }
                                                                    data={ this.state.content }
                                                                    onChange={ ( event, editor ) => {
                                                                        const data = editor.getData();
                                                                        this.setState({
                                                                            content: data
                                                                        })
                                                                    } }
                                                                />
                                                            </FormGroup>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col xl={4} lg={5} sm={12}>
                                                    <Card>
                                                        <CardBody>
                                                            <FormGroup>
                                                                <Label for="groupEmailId">Nhóm email</Label>
                                                                <select name="groupEmailId" id="groupEmailId"
                                                                        className="form-control" onChange={ this.change }
                                                                        defaultValue={ this.state.groupEmailId }
                                                                >
                                                                    {
                                                                        this.state.listGroupEmail.map( (groupEmail, key) => (
                                                                            <option value={ groupEmail.id } key={key}>{ groupEmail.title }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </FormGroup>
                                                            <Button className="btn-block" type="button" onClick={ () => this.createSystemEmail() } disabled={ this.state.btnSubmit }>Chỉnh sửa</Button>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </>
                                        )
                                    }
                                </Row>
                            </Form>
                            <TipEmailComponent />
                        </>
                    )
                }
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminServiceEditEmail' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceEditEmailComponent);